// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
// Add Firestore import
import { getFirestore, collection, doc, setDoc, addDoc, orderBy, onSnapshot, serverTimestamp, query } from 'firebase/firestore';
import { getMessaging, Messaging } from 'firebase/messaging';
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});

// Export Firestore database instance
export const db = getFirestore(app);

// Export Firestore functions for chat
export const firestore = {
  collection: (collectionName: string) => {
    console.log('🔥 Firestore collection called:', collectionName);
    return {
      doc: (docId: string) => {
        return {
          collection: (subCollectionName: string) => {
            return {
              orderBy: (field: string, direction: 'asc' | 'desc' = 'asc') => {
                return {
                  onSnapshot: (callback: (snapshot: any) => void) => {
                    const q = query(
                      collection(db, collectionName, docId, subCollectionName),
                      orderBy(field, direction)
                    );
                    return onSnapshot(q, callback);
                  }
                };
              },
              add: (data: any) => {
                return addDoc(collection(db, collectionName, docId, subCollectionName), data);
              }
            };
          },
          set: (data: any, options?: any) => {
            return setDoc(doc(db, collectionName, docId), data, options);
          }
        };
      }
    };
  },
  FieldValue: {
    serverTimestamp: () => {
      return serverTimestamp();
    }
  }
};

// Initialize Cloud Messaging and get a reference to the messaging service
// Only initialize if we're in a browser environment with required APIs
let messaging: Messaging | null = null;
try {
  if (typeof window !== 'undefined' && 
      typeof navigator !== 'undefined' &&
      'serviceWorker' in navigator && 
      'Notification' in window) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.warn('[Firebase] Messaging initialization failed:', error);
  messaging = null;
}
export { messaging };

export default app; 